import React from 'react';
import styled from 'styled-components';
import { MediaData } from '~admin/model/media-data';

interface Props {
  media: MediaData;
}

export const MediaPreviewImage: React.FunctionComponent<Props> = ({ media }) => {
  const { url, description } = media;
  return <Image src={url} alt={description} />;
};

const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`;



// WEBPACK FOOTER //
// ./view/components/ui/form/fields/media/media-preview/media-preview-image.component.tsx